
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 299 299","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M297.873 174.902c0-7.81-6.34-14.151-14.15-14.151H14.574c-7.81 0-14.15 6.34-14.15 14.151v28.302c0 7.81 6.34 14.15 14.15 14.15h269.149c7.81 0 14.15-6.34 14.15-14.15v-28.302zM297.873 95.734c0-7.81-6.34-14.151-14.15-14.151H14.574c-7.81 0-14.15 6.341-14.15 14.151v28.302c0 7.81 6.34 14.15 14.15 14.15h269.149c7.81 0 14.15-6.34 14.15-14.15V95.734z"}})])
          )
        }
      }
    